const translations = {
    stepCount: 'step {{stepCount}} of 3'
};

export default translations;
